import React from "react";
import type { CipherText } from "@b2bportal/purchase-api";
import { cartQuoteSelectors, useCheckoutState } from "@hopper-b2b/checkout";
import { useCheckoutStateSelector as useSelector } from "@hopper-b2b/checkout";
import { PaymentScreenHandler } from "../../../../checkout";
import { type TEvent, Event } from "../../events";
import type { FlightMachineContext } from "../../types";

export const PaymentLoader = () => {
  const [, send] = useCheckoutState<TEvent, FlightMachineContext>();

  const priceQuoteCipherText = useSelector(
    cartQuoteSelectors.getPriceQuoteCipherText
  );

  const goToPrevStep = () => {
    send({
      type: Event.PREVIOUS,
    });
  };

  const goToNextStep = (
    paymentSessionToken: string,
    priceQuoteCipherText: CipherText
  ) => {
    // Update state with quote token received from uber payments
    send({
      type: Event.SET_PAYMENT_DATA_AND_GO_NEXT,
      paymentQuoteToken: priceQuoteCipherText,
      paymentSessionToken: paymentSessionToken,
    });
  };

  const handleError = () => {
    return;
  };

  return priceQuoteCipherText ? (
    <PaymentScreenHandler
      goToPrevStep={goToPrevStep}
      goToNextStep={goToNextStep}
      handleError={handleError}
      priceQuoteCipherText={priceQuoteCipherText}
    />
  ) : null;
};
